import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="password-toggle"
export default class extends Controller {
  static targets = ["input", "toggle"]
  static classes = ["visible", "hidden"]
  
  connect() {
    this.visible = false
  }

  toggle(event) {
    event.preventDefault()
    if (!this.visible) {
      this.inputTarget.type = "text"
      this.toggleTarget.classList.add(this.visibleClass)
      this.toggleTarget.classList.remove(this.hiddenClass)
    } else {
      this.inputTarget.type = "password"

      this.toggleTarget.classList.add(this.hiddenClass)
      this.toggleTarget.classList.remove(this.visibleClass)
    }

    this.visible = !this.visible
  }
}
